import { json2xml } from "../json/json2xml";
import { msalInstance } from "../index";
import Joi from "joi-browser";
import { toast } from "react-toastify";
import moment from "moment";
import cryptoRandomString from "crypto-random-string";
import {
  getFormsySubmission,
  getFormsyConfig,
  getClientPrograms,
  getCareTeam,
  getFormsySubmissionsByIds,
  getFormsySubmissionsByFormIdForClient,
  sendEmail,
  writeErrorLog,
  writeProcessLog,
  writeShareLog,
} from "../components/services/soar";
import { getFieldName, getFieldDate } from "./helperScripts";
const org =
  process.env.REACT_APP_ENVIRONMENT === "Production" ? "ReactLive" : "ReactDev";
const logOrg =
  process.env.REACT_APP_ENVIRONMENT === "Production"
    ? "ReactLive"
    : process.env.REACT_APP_ENVIRONMENT === "DevOps Test"
    ? " ReactTest"
    : process.env.REACT_APP_ENVIRONMENT === "Development"
    ? "ReactDev"
    : "ReactIdk";

export async function getSubmission(submissionid) {
  console.log("Getting Form Submission for ", submissionid);
  const response = await getFormsySubmission(submissionid);

  if (!response) {
    return;
  }

  const formsyResponse = JSON.parse(response);
  console.log("Formsy Response: ", formsyResponse);

  if (
    !formsyResponse ||
    !formsyResponse.FormSubmission ||
    !formsyResponse.FormSubmission.Submission ||
    !formsyResponse.FormSubmission.Submission[0]
  ) {
    return;
  }

  console.log("Parsing Formsy Data");
  const returnObj = {};

  if (formsyResponse.FormSubmission.Submission[0].Comments.comments) {
    const comments = json2xml(
      formsyResponse.FormSubmission.Submission[0].Comments.comments,
      {
        compact: true,
        ignoreComment: true,
      }
    );
    returnObj.Comments = comments;
    console.log("Comments XML", comments);
  }

  if (
    formsyResponse.FormSubmission.Submission[0].Signatures &&
    formsyResponse.FormSubmission.Submission[0].Signatures !== "" &&
    formsyResponse.FormSubmission.Submission[0].Signatures.signatures
  ) {
    const signatures = Array.isArray(
      formsyResponse.FormSubmission.Submission[0].Signatures.signatures
    )
      ? formsyResponse.FormSubmission.Submission[0].Signatures.signatures
      : [formsyResponse.FormSubmission.Submission[0].Signatures.signatures];

    returnObj.Signatures = signatures;

    console.log("Signatures Loaded:", signatures);
  }

  returnObj.Data =
    formsyResponse.FormSubmission.Submission[0].FormResults.results;

  for (const key in returnObj.Data) {
    for (const prop in returnObj.Data[key]) {
      returnObj.Data[key][prop.replace("@", "")] = returnObj.Data[key][prop];
      delete returnObj.Data[key][prop];
    }
  }

  returnObj.FormsyDetails = formsyResponse.FormSubmission.Submission[0];
  return returnObj;
}

export async function getConfig(formid) {
  const response = await getFormsyConfig(formid);

  if (!response) {
    return;
  }

  const formsyInfo = JSON.parse(response);
  if (!formsyInfo?.Formsy?.MyForm?.[0]) {
    return;
  }

  const myFormConfig = formsyInfo.Formsy.MyForm[0];
  console.log("FormsyConfig:", myFormConfig);
  // document.title = `SAFY Portal - ${myFormConfig.FormDescription}`;

  for (const key in myFormConfig.FormConfiguration[0].config[0]) {
    for (const prop in myFormConfig.FormConfiguration[0].config[0][key]) {
      myFormConfig.FormConfiguration[0].config[0][key][prop.replace("@", "")] =
        myFormConfig.FormConfiguration[0].config[0][key][prop];
      delete myFormConfig.FormConfiguration[0].config[0][key][prop];
    }
  }

  return myFormConfig;
}

export async function getClientData(clientid, existingForm, formName) {
  console.log("Forms, Get Client Data for " + clientid);
  const response = await getClientPrograms(clientid);

  if (!response) {
    return;
  }

  console.log("getClientPrograms: ", response);
  var today = moment().startOf("day");

  const programOptions = response
    .filter((clientProgram) => {
      if (
        getFieldName(clientProgram["unit.ccx_programtype"]) === "Foster Home"
      ) {
        return false;
      }

      if (existingForm) {
        return true;
      }

      if (!clientProgram["unit.sor_safyportalconfig"]) {
        return false;
      }

      const checkConfig = (formNameToCheck) => {
        const portalConfig =
          clientProgram["unit.sor_safyportalconfig"].toLowerCase();
        if (
          !portalConfig?.includes(formNameToCheck) ||
          portalConfig.includes(formNameToCheck + ":Removed")
        ) {
          return false;
        }

        if (
          clientProgram.ccx_dischargedate === undefined &&
          clientProgram.ccx_administrativeclosedate === undefined
        ) {
          return true;
        }

        return (
          clientProgram.ccx_administrativeclosedate !== undefined &&
          moment(
            getFieldDate(clientProgram.ccx_administrativeclosedate)
          ).isSameOrAfter(today)
        );
      };

      if (checkConfig(formName.toLowerCase())) {
        return true;
      } else {
        var regex = /[v]\d/;
        let match = regex.exec(formName.toLowerCase());
        //console.log("Checking Form Version and RegEx Match", formName, match);
        let coreForm;
        if (match?.index) {
          coreForm = formName.toLowerCase().substring(0, match.index);
          return checkConfig(coreForm);
        }

        return false;
      }
    })
    .map((clientProgram) => ({
      _id: clientProgram.ccx_client_programid,
      name: `${getFieldName(clientProgram.ccx_programunit)} - (${getFieldDate(
        clientProgram.ccx_admitdate
      )}-${getFieldDate(clientProgram.ccx_dischargedate) || "no date"})`,
    }));

  const clientData = {
    programs: response,
    programOptions: programOptions,
    client: {
      id: response[0]["con.contactid"],
      fullName: response[0]["con.fullname"],
      firstName: response[0]["con.firstname"],
      lastName: response[0]["con.lastname"],
      sex: response[0]["con.gendercode"],
      dob: response[0]["con.birthdate"],
      mpi: response[0]["con.ccx_mpistr"],
      ssn: response[0]["con.ccx_ssn"],
      email: response[0]["con.emailaddress1"],
      phone: response[0]["con.telephone2"],
      sor_clientflags: response[0]["con.sor_clientflags"]?.split(",") || [],
    },
  };

  return clientData;
}

export async function getCareTeams(clientid) {
  console.log("Forms, Get Care Team Data for " + clientid);
  const response = await getCareTeam(clientid);

  if (!response) {
    return;
  }

  console.log("Care Team", response);
  return response;
}

function convertFormData(formData, formsyDetails, comments, signatures) {
  const safyInfo = JSON.parse(localStorage.getItem("safyInfo"));
  let formDataObj = {};
  for (const property in formData) {
    const formDataProperty = formData[property];

    let obj = {};
    for (const attr in formDataProperty)
      obj[attr.replace("@", "").replace("#", "")] = formDataProperty[attr];

    obj.label = obj.label
      ?.replaceAll("&", "&amp;")
      .replaceAll(`"`, "&quot;")
      .replaceAll("'", "&apos;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;");

    if (obj.value !== undefined) {
      console.log(`convertFormData${property}:`, obj.value);
      obj.value = obj.value
        .replaceAll("&", "&amp;")
        .replaceAll(`"`, "&quot;")
        .replaceAll("'", "&apos;")
        .replaceAll("<", "&lt;")
        .replaceAll(">", "&gt;");
    }

    formDataObj[property] = {
      _attributes: obj,
    };
  }
  console.log("ConvertFormData: ", formDataObj);
  let dataObj = `<results>${json2xml(formDataObj, {
    compact: true,
    ignoreComment: true,
  })}</results>`.replaceAll("\n", "&#10;");
  //return dataObj;

  const resultsObj = { ...formsyDetails };
  resultsObj.FormResults = dataObj;
  resultsObj.Comments = comments
    ? "<comments>" + comments + "</comments>"
    : "<comments></comments>";
  resultsObj.Signatures = signatures ? convertSignatures(signatures) : "";
  resultsObj.ModifiedById = safyInfo.user.safyInfo.AzureAdId;
  resultsObj.ModifiedByName = safyInfo.user.displayName;
  resultsObj.LastModifiedOn = resultsObj.ModifiedOn;
  delete resultsObj.CreatedOn;
  delete resultsObj.ModifiedOn;
  delete resultsObj.InDevelopment;
  delete resultsObj.Active;
  delete resultsObj.FormName;

  return resultsObj;
}

const convertSignatures = (signatures) => {
  if (!signatures || signatures.length === 0) {
    return "";
  }

  console.log("Convert Signatures: ", signatures);
  let signatureXml = "";

  for (const signature in signatures) {
    signatureXml += "<signatures>";

    for (const property in signatures[signature]) {
      signatureXml += `<${property}>${signatures[signature][property]}</${property}>`;
    }
    signatureXml += "</signatures>";
  }

  console.log("Final Signature XML", signatureXml);
  return signatureXml;
};

export async function saveForm(
  data,
  formsyDetails,
  comments,
  signatures,
  navigate,
  location,
  isAutoSave = false
) {
  console.group("saveForm");
  const safyInfo = JSON.parse(localStorage.getItem("safyInfo"));
  const path = location.pathname.split("/")[1];
  const formid = location.pathname.split("/")[2];
  const clientid = location.pathname.split("/")[3];
  const formData = { ...data };

  console.log("formData:", formData);
  console.log("formsyDetails:", formsyDetails);
  console.log("comments:", comments);
  console.log("signatures:", signatures);
  const resultsObj = convertFormData(
    formData,
    formsyDetails,
    comments,
    signatures
  );

  console.log("Form Save Object", JSON.stringify(resultsObj));
  const action = formsyDetails.SubmissionId ? "Update" : "Insert";
  console.log("Form Save Action, ", action);
  let toastId;
  let errorUrl = "https://eurekaapi.azurewebsites.net/access_as_user";
  let responseJson;

  try {
    var accessToken = await msalInstance.acquireTokenSilent({
      scopes: ["https://eurekaapi.azurewebsites.net/access_as_user"],
    });

    errorUrl = `Formsy/Upsert/Submission/${org}/${action}`;

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${accessToken.accessToken}`);

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify(resultsObj),
    };

    if (!isAutoSave) {
      toastId = toast.loading("Saving...", {
        type: toast.TYPE.INFO,
      });

      const trimmedResults = { ...resultsObj };
      delete trimmedResults.FormResults;
      delete trimmedResults.Signatures;
      delete trimmedResults.Comments;

      const logData = {
        Type: `Formsy ${action}`,
        Location: org,
        Description: location.pathname,
        Data: JSON.stringify(trimmedResults),
        ObjectReferenceType: "Form",
        ObjectReferenceId: trimmedResults.SubmissionId,
      };

      writeProcessLog(logData);
    }

    console.groupEnd();
    const response = await fetch(
      `https://eurekaapi.azurewebsites.net/Formsy/Upsert/Submission/${org}/${action}`,
      requestOptions
    );

    if (!response) {
      return;
    }

    responseJson = await response.json();

    if (!responseJson) {
      return;
    }

    let dataJson;

    try {
      dataJson = JSON.parse(responseJson);
    } catch (jsonError) {
      if (toastId) {
        toast.update(toastId, {
          render: "An error has occurred.",
          type: toast.TYPE.ERROR,
          autoClose: 5000,
          isLoading: false,
          closeOnClick: true,
        });
      } else {
        toast.error(`An ${isAutoSave ? "auto save " : ""}error has occurred.`);
      }

      const fullError = {
        ...JSON.parse(
          JSON.stringify(jsonError, Object.getOwnPropertyNames(jsonError))
        ),
        responseJson: responseJson,
      };
      const logData = {
        Who: `${safyInfo.user.domainName}|${safyInfo.user.displayName}`,
        FullError: JSON.stringify(fullError),
        API: "Eureka API/JSON",
        APIBody: JSON.stringify(resultsObj),
        URL: `Formsy/Upsert/Submission/${org}/${action}`,
        Org: org,
        ResponseCode: null,
        ResponseMessage: jsonError.message,
        ExceptionType: `Formsy ${isAutoSave ? "Auto " : ""}Save Error`,
        Application: "React Portal/Formsy",
      };

      writeErrorLog(logData);
      return;
    }
    console.log("dataJson", dataJson);

    if (dataJson?.SystemResponse?.[0]?.Code === "SUCCESS") {
      if (toastId) {
        toast.update(toastId, {
          render: dataJson.SystemResponse[0].Message,
          type: toast.TYPE.SUCCESS,
          autoClose: 5000,
          isLoading: false,
          closeOnClick: true,
        });
      }

      if (!isAutoSave) {
        const successLogData = {
          Type: `Formsy ${action} Success`,
          Location: org,
          Description: location.pathname,
          Data: JSON.stringify(data),
          ObjectReferenceType: "Form",
          ObjectReferenceId: dataJson.SystemResponse[0].Id,
        };

        writeProcessLog(successLogData);
      }

      if (action === "Insert") {
        //redirect to submission url
        navigate?.(
          `/${path}/${formid}${clientid ? `/${clientid}` : ""}/${
            dataJson.SystemResponse[0].Id
          }`,
          { replace: true, state: location.state }
        );
      } else {
        return {
          Id: dataJson.SystemResponse[0].Id,
          LastModifiedOn: dataJson.SystemResponse[0].LastModifiedOn,
        };
      }
    } else if (dataJson?.SystemResponse?.[0]?.Message.includes("stale data")) {
      if (toastId) {
        toast.update(toastId, {
          render:
            "This form has been updated by another user. You must refresh to get the latest data.",
          type: toast.TYPE.ERROR,
          isLoading: false,
          closeOnClick: true,
        });
      } else {
        toast.error(
          "This form has been updated by another user. You must refresh to get the latest data."
        );
      }
    } else {
      console.log(
        "FormsySaveError",
        dataJson.SystemResponse[0].Message,
        resultsObj
      );

      const logData = {
        Who: `${safyInfo.user.domainName}|${safyInfo.user.displayName}`,
        FullError: JSON.stringify(dataJson),
        API: "Eureka API",
        APIBody: JSON.stringify(resultsObj),
        URL: `Formsy/Upsert/Submission/${org}/${action}`,
        Org: org,
        ResponseCode: dataJson.SystemResponse[0].Code,
        ResponseMessage: dataJson.SystemResponse[0].Message,
        ExceptionType: `Formsy ${isAutoSave ? "Auto " : ""}Save Error`,
        Application: "React Portal/Formsy",
      };

      writeErrorLog(logData);

      if (toastId) {
        toast.update(toastId, {
          render: "An error has occurred.",
          type: toast.TYPE.ERROR,
          autoClose: 5000,
          isLoading: false,
          closeOnClick: true,
        });
      } else {
        toast.error(`An ${isAutoSave ? "auto save " : ""}error has occurred.`);
      }
    }
  } catch (error) {
    const logData = {
      Who: `${safyInfo.user.domainName}|${safyInfo.user.displayName}`,
      FullError: JSON.stringify(error, Object.getOwnPropertyNames(error)),
      API: "Eureka API/JS",
      APIBody: JSON.stringify(resultsObj),
      URL: errorUrl,
      Org: org,
      ResponseCode: null,
      ResponseMessage: error.message,
      ExceptionType: null,
      Application: "React Portal/Formsy",
    };

    writeErrorLog(logData);

    if (toastId) {
      toast.update(toastId, {
        render: `An error has occurred: ${error.message}`,
        type: toast.TYPE.ERROR,
        autoClose: false,
        isLoading: false,
        closeOnClick: true,
      });
    } else {
      toast.error(
        `An ${isAutoSave ? "auto save " : ""}error has occurred: ${
          error.message
        }`,
        { autoClose: false, closeOnClick: true }
      );
    }
  }
}

export async function saveFormQuietly(
  data,
  formsyDetails,
  comments,
  signatures,
  navigate,
  location,
  isAutoSave = false
) {
  console.group("saveForm");
  const safyInfo = JSON.parse(localStorage.getItem("safyInfo"));
  const path = location.pathname.split("/")[1];
  const formid = location.pathname.split("/")[2];
  const clientid = location.pathname.split("/")[3];
  const formData = { ...data };

  console.log("formData:", formData);
  console.log("formsyDetails:", formsyDetails);
  console.log("comments:", comments);
  console.log("signatures:", signatures);
  const resultsObj = convertFormData(
    formData,
    formsyDetails,
    comments,
    signatures
  );

  console.log("Form Save Object", JSON.stringify(resultsObj));
  const action = formsyDetails.SubmissionId ? "Update" : "Insert";
  console.log("Form Save Action, ", action);
  let errorUrl = "https://eurekaapi.azurewebsites.net/access_as_user";

  try {
    var accessToken = await msalInstance.acquireTokenSilent({
      scopes: ["https://eurekaapi.azurewebsites.net/access_as_user"],
    });

    errorUrl = `Formsy/Upsert/Submission/${org}/${action}`;

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${accessToken.accessToken}`);

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify(resultsObj),
    };

    if (!isAutoSave) {
      const trimmedResults = { ...resultsObj };
      delete trimmedResults.FormResults;
      delete trimmedResults.Signatures;
      delete trimmedResults.Comments;

      const logData = {
        Type: `Formsy ${action}`,
        Location: org,
        Description: location.pathname,
        Data: JSON.stringify(trimmedResults),
        ObjectReferenceType: "Form",
        ObjectReferenceId: trimmedResults.SubmissionId,
      };

      writeProcessLog(logData);
    }

    console.groupEnd();
    const response = await fetch(
      `https://eurekaapi.azurewebsites.net/Formsy/Upsert/Submission/${org}/${action}`,
      requestOptions
    );

    if (!response) {
      return;
    }

    const responseJson = await response.json();

    if (!responseJson) {
      return;
    }

    let dataJson;

    try {
      dataJson = JSON.parse(responseJson);
    } catch (jsonError) {
      toast.error(`An ${isAutoSave ? "auto save " : ""}error has occurred.`);

      const fullError = {
        ...JSON.parse(
          JSON.stringify(jsonError, Object.getOwnPropertyNames(jsonError))
        ),
        responseJson: responseJson,
      };
      const logData = {
        Who: `${safyInfo.user.domainName}|${safyInfo.user.displayName}`,
        FullError: JSON.stringify(fullError),
        API: "Eureka API/JSON",
        APIBody: JSON.stringify(resultsObj),
        URL: `Formsy/Upsert/Submission/${org}/${action}`,
        Org: org,
        ResponseCode: null,
        ResponseMessage: jsonError.message,
        ExceptionType: `Formsy ${isAutoSave ? "Auto " : ""}Save Error`,
        Application: "React Portal/Formsy",
      };

      writeErrorLog(logData);
      return;
    }
    console.log("dataJson", dataJson);

    if (dataJson.SystemResponse?.[0]?.Code === "SUCCESS") {
      if (!isAutoSave) {
        const successLogData = {
          Type: `Formsy ${action} Success`,
          Location: org,
          Description: location.pathname,
          Data: JSON.stringify(data),
          ObjectReferenceType: "Form",
          ObjectReferenceId: dataJson.SystemResponse[0].Id,
        };

        writeProcessLog(successLogData);
      }

      if (action === "Insert") {
        //redirect to submission url
        navigate?.(
          `/${path}/${formid}${clientid ? `/${clientid}` : ""}/${
            dataJson.SystemResponse[0].Id
          }`,
          { replace: true, state: location.state }
        );
      } else {
        return {
          Id: dataJson.SystemResponse[0].Id,
          LastModifiedOn: dataJson.SystemResponse[0].LastModifiedOn,
        };
      }
    } else if (dataJson?.SystemResponse?.[0]?.Message.includes("stale data")) {
      toast.error(
        "This form has been updated by another user. You must refresh to get the latest data."
      );
    } else {
      console.log(
        "FormsySaveError",
        dataJson.SystemResponse[0].Message,
        resultsObj
      );

      const logData = {
        Who: `${safyInfo.user.domainName}|${safyInfo.user.displayName}`,
        FullError: JSON.stringify(dataJson),
        API: "Eureka API",
        APIBody: JSON.stringify(resultsObj),
        URL: `Formsy/Upsert/Submission/${org}/${action}`,
        Org: org,
        ResponseCode: dataJson.SystemResponse[0].Code,
        ResponseMessage: dataJson.SystemResponse[0].Message,
        ExceptionType: `Formsy ${isAutoSave ? "Auto " : ""}Save Error`,
        Application: "React Portal/Formsy",
      };

      writeErrorLog(logData);
      toast.error("An error has occurred.", {
        autoClose: 5000,
        isLoading: false,
        closeOnClick: true,
      });
    }
  } catch (error) {
    const logData = {
      Who: `${safyInfo.user.domainName}|${safyInfo.user.displayName}`,
      FullError: JSON.stringify(error, Object.getOwnPropertyNames(error)),
      API: "Eureka API/JS",
      APIBody: JSON.stringify(resultsObj),
      URL: errorUrl,
      Org: org,
      ResponseCode: null,
      ResponseMessage: error.message,
      ExceptionType: null,
      Application: "React Portal/Formsy",
    };

    writeErrorLog(logData);
    toast.error("An error has occurred.", {
      autoClose: false,
      closeOnClick: true,
    });
  }
}

export async function saveFormWithCompliancy(
  data,
  formsyDetails,
  formsyConfig,
  comments,
  signatures,
  navigate,
  location,
  isAutoSave = false
) {
  console.group("saveForm");
  const safyInfo = JSON.parse(localStorage.getItem("safyInfo"));
  const path = location.pathname.split("/")[1];
  const formid = location.pathname.split("/")[2];
  const clientid = location.pathname.split("/")[3];
  const formData = { ...data };

  console.log("formData:", formData);
  console.log("formsyDetails:", formsyDetails);
  console.log("comments:", comments);
  console.log("signatures:", signatures);
  const resultsObj = convertFormData(
    formData,
    formsyDetails,
    comments,
    signatures
  );

  if (formsyDetails.FinalSigned === "1") {
    let helperConfig = JSON.parse(formsyConfig.HelperConfiguration[0]);

    if (helperConfig.compliancy) {
      const compliancyValues = {};
      const compliancyFields = helperConfig.compliancy.split(",");
      compliancyFields.forEach((field) => {
        const fieldMap = field.split(":");
        compliancyValues[fieldMap[1] || fieldMap[0]] =
          formData[fieldMap[0]].value;
      });

      resultsObj.CompliancyConfiguration = JSON.stringify(compliancyValues);
    }
  }

  console.log("Form Save Object", JSON.stringify(resultsObj));
  const action = formsyDetails.SubmissionId ? "Update" : "Insert";
  console.log("Form Save Action, ", action);
  let toastId;
  let errorUrl = "https://eurekaapi.azurewebsites.net/access_as_user";

  try {
    var accessToken = await msalInstance.acquireTokenSilent({
      scopes: ["https://eurekaapi.azurewebsites.net/access_as_user"],
    });

    errorUrl = `Formsy/Upsert/Submission/${org}/${action}`;

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${accessToken.accessToken}`);

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify(resultsObj),
    };

    if (!isAutoSave) {
      toastId = toast.loading("Saving...", {
        type: toast.TYPE.INFO,
      });

      const trimmedResults = { ...resultsObj };
      delete trimmedResults.FormResults;
      delete trimmedResults.Signatures;
      delete trimmedResults.Comments;

      const logData = {
        Type: `Formsy ${action}`,
        Location: org,
        Description: location.pathname,
        Data: JSON.stringify(trimmedResults),
        ObjectReferenceType: "Form",
        ObjectReferenceId: trimmedResults.SubmissionId,
      };

      writeProcessLog(logData);
    }

    console.groupEnd();
    const response = await fetch(
      `https://eurekaapi.azurewebsites.net/Formsy/Upsert/Submission/${org}/${action}`,
      requestOptions
    );

    if (!response) {
      return;
    }

    const responseJson = await response.json();

    if (!responseJson) {
      return;
    }

    let dataJson;

    try {
      dataJson = JSON.parse(responseJson);
    } catch (jsonError) {
      if (toastId) {
        toast.update(toastId, {
          render: "An error has occurred.",
          type: toast.TYPE.ERROR,
          autoClose: 5000,
          isLoading: false,
          closeOnClick: true,
        });
      } else {
        toast.error(`An ${isAutoSave ? "auto save " : ""}error has occurred.`);
      }

      const fullError = {
        ...JSON.parse(
          JSON.stringify(jsonError, Object.getOwnPropertyNames(jsonError))
        ),
        responseJson: responseJson,
      };
      const logData = {
        Who: `${safyInfo.user.domainName}|${safyInfo.user.displayName}`,
        FullError: JSON.stringify(fullError),
        API: "Eureka API/JSON",
        APIBody: JSON.stringify(resultsObj),
        URL: `Formsy/Upsert/Submission/${org}/${action}`,
        Org: org,
        ResponseCode: null,
        ResponseMessage: jsonError.message,
        ExceptionType: `Formsy ${isAutoSave ? "Auto " : ""}Save Error`,
        Application: "React Portal/Formsy",
      };

      writeErrorLog(logData);
      return;
    }
    console.log("dataJson", dataJson);

    if (dataJson.SystemResponse?.[0]?.Code === "SUCCESS") {
      if (toastId) {
        toast.update(toastId, {
          render: dataJson.SystemResponse[0].Message,
          type: toast.TYPE.SUCCESS,
          autoClose: 5000,
          isLoading: false,
          closeOnClick: true,
        });
      }

      if (!isAutoSave) {
        const successLogData = {
          Type: `Formsy ${action} Success`,
          Location: org,
          Description: location.pathname,
          Data: JSON.stringify(data),
          ObjectReferenceType: "Form",
          ObjectReferenceId: dataJson.SystemResponse[0].Id,
        };

        writeProcessLog(successLogData);
      }

      if (action === "Insert") {
        //redirect to submission url
        navigate(
          `/${path}/${formid}${clientid ? `/${clientid}` : ""}/${
            dataJson.SystemResponse[0].Id
          }`,
          { replace: true, state: location.state }
        );
      } else {
        return {
          Id: dataJson.SystemResponse[0].Id,
          LastModifiedOn: dataJson.SystemResponse[0].LastModifiedOn,
        };
      }
    } else if (dataJson?.SystemResponse?.[0]?.Message.includes("stale data")) {
      if (toastId) {
        toast.update(toastId, {
          render:
            "This form has been updated by another user. You must refresh to get the latest data.",
          type: toast.TYPE.ERROR,
          isLoading: false,
          closeOnClick: true,
        });
      } else {
        toast.error(
          "This form has been updated by another user. You must refresh to get the latest data."
        );
      }
    } else {
      console.log(
        "FormsySaveError",
        dataJson.SystemResponse[0].Message,
        resultsObj
      );

      const logData = {
        Who: `${safyInfo.user.domainName}|${safyInfo.user.displayName}`,
        FullError: JSON.stringify(dataJson),
        API: "Eureka API",
        APIBody: JSON.stringify(resultsObj),
        URL: `Formsy/Upsert/Submission/${org}/${action}`,
        Org: org,
        ResponseCode: dataJson.SystemResponse[0].Code,
        ResponseMessage: dataJson.SystemResponse[0].Message,
        ExceptionType: `Formsy ${
          isAutoSave ? "Auto " : ""
        }Save w/Compliancy Error`,
        Application: "React Portal/Formsy",
      };

      writeErrorLog(logData);

      if (toastId) {
        toast.update(toastId, {
          render: "An error has occurred.",
          type: toast.TYPE.ERROR,
          autoClose: 5000,
          isLoading: false,
          closeOnClick: true,
        });
      } else {
        toast.error(`An ${isAutoSave ? "auto save " : ""}error has occurred.`);
      }
    }
  } catch (error) {
    const logData = {
      Who: `${safyInfo.user.domainName}|${safyInfo.user.displayName}`,
      FullError: JSON.stringify(error, Object.getOwnPropertyNames(error)),
      API: "Eureka API/JS",
      APIBody: JSON.stringify(resultsObj),
      URL: errorUrl,
      Org: org,
      ResponseCode: null,
      ResponseMessage: error.message,
      ExceptionType: null,
      Application: "React Portal/Formsy",
    };

    writeErrorLog(logData);

    if (toastId) {
      toast.update(toastId, {
        render: `An error has occurred: ${error.message}`,
        type: toast.TYPE.ERROR,
        autoClose: false,
        isLoading: false,
        closeOnClick: true,
      });
    } else {
      toast.error(
        `An ${isAutoSave ? "auto save " : ""}error has occurred: ${
          error.message
        }`,
        { autoClose: false, closeOnClick: true }
      );
    }
  }
}

export async function cloneForm(
  data,
  formsyDetails,
  comments,
  signatures,
  navigate,
  location,
  formsyConfig
) {
  console.group("Formsy Clone");
  let path = location.pathname.split("/")[1];
  let formid = location.pathname.split("/")[2];
  const clientid = location.pathname.split("/")[3];
  const safyInfo = JSON.parse(localStorage.getItem("safyInfo")).user;

  const formData = { ...data };
  console.log("Form Data", formData);

  const helperConfig =
    formsyConfig.HelperConfiguration && formsyConfig.HelperConfiguration[0]
      ? JSON.parse(formsyConfig.HelperConfiguration[0])
      : {};
  console.log("Helper Config", helperConfig);

  const excludeCloning = helperConfig.excludeCloning || [];

  for (const fieldName of excludeCloning) {
    const field = formData[fieldName];
    const existingValue = field !== undefined ? field.value : undefined;

    if (existingValue === undefined) {
      continue;
    }

    if (
      existingValue === "[]" ||
      (existingValue.startsWith("[{") && existingValue.endsWith("}]"))
    ) {
      if (
        !formsyConfig.FormConfiguration[0].config[0][fieldName]["@emptyOnClone"]
      ) {
        // eslint-disable-next-line no-useless-escape
        formData[fieldName].value = `[{"_id":"${cryptoRandomString(
          10
        )}","IsEditable":true}]`;
      } else {
        formData[fieldName].value = "[]";
      }
    } else formData[fieldName].value = "";
  }

  // for when you want to exclude specific columns from a "table" field
  // example: excludeCloningTables: [{"tableName": "TableA", "fieldsExcluded": ["FieldA", "FieldB"]}]
  const excludeCloningTables = helperConfig.excludeCloningTables || [];

  console.group("Exclude Cloning");
  excludeCloningTables.forEach((tableInfo) => {
    console.log("Table Info", tableInfo);

    const tableData =
      formData[tableInfo.tableName] !== undefined &&
      formData[tableInfo.tableName].value !== undefined &&
      formData[tableInfo.tableName].value.startsWith("[{") &&
      formData[tableInfo.tableName].value.endsWith("}]")
        ? JSON.parse(formData[tableInfo.tableName].value)
        : [];

    if (tableData !== undefined) {
      console.log("Table Data", tableData);
      tableData.forEach((tableRow) => {
        tableInfo.fieldsExcluded.forEach((fieldName) => {
          tableRow[fieldName] = "";
        });
      });
      console.log("Excluded Table Data", tableData);
      formData[tableInfo.tableName].value = JSON.stringify(tableData);
    }
  });
  console.groupEnd();

  console.log("Pre Clone Data:", formData);

  const resultsObj = convertFormData(
    formData,
    formsyDetails,
    comments,
    signatures
  );
  resultsObj.Comments = "";
  resultsObj.Signatures = "";
  resultsObj.FinalSigned = "0";
  resultsObj.FinalSignedDate = "";
  resultsObj.Active = "1";
  resultsObj.CreatedById = safyInfo.safyInfo.AzureAdId;
  resultsObj.CreatedByName = safyInfo.displayName;
  resultsObj.ModifiedById = safyInfo.safyInfo.AzureAdId;
  resultsObj.ModifiedByName = safyInfo.displayName;

  if (helperConfig.buttonBarConfig.cloneVersion) {
    const setupConfig =
      formsyConfig.SetupConfiguration && formsyConfig.SetupConfiguration[0]
        ? JSON.parse(formsyConfig.SetupConfiguration[0])
        : {};
    path = `${setupConfig.formPath}v${helperConfig.buttonBarConfig.cloneVersion.versionNumber}`;
    resultsObj.FormVersionId = helperConfig.buttonBarConfig.cloneVersion.id;
    formid = helperConfig.buttonBarConfig.cloneVersion.id;
  }

  console.log("Form Clone Object", JSON.stringify(resultsObj));

  var accessToken = await msalInstance.acquireTokenSilent({
    scopes: ["https://eurekaapi.azurewebsites.net/access_as_user"],
  });

  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", `Bearer ${accessToken.accessToken}`);

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: JSON.stringify(resultsObj),
  };
  const toastId = toast.loading("Cloning...", {
    type: toast.TYPE.INFO,
  });
  fetch(
    `https://eurekaapi.azurewebsites.net/Formsy/Upsert/Submission/${org}/Insert`,
    requestOptions
  )
    .then((response) => response.json())
    .then((data) => {
      let dataJson;

      try {
        dataJson = JSON.parse(data);
      } catch (jsonError) {
        if (toastId) {
          toast.update(toastId, {
            render: "An error has occurred.",
            type: toast.TYPE.ERROR,
            autoClose: 5000,
            isLoading: false,
            closeOnClick: true,
          });
        } else {
          toast.error("An error has occurred.");
        }

        const fullError = {
          ...JSON.parse(
            JSON.stringify(jsonError, Object.getOwnPropertyNames(jsonError))
          ),
          responseJson: data,
        };
        const logData = {
          Who: `${safyInfo.user.domainName}|${safyInfo.user.displayName}`,
          FullError: JSON.stringify(fullError),
          API: "Eureka API/JS",
          APIBody: JSON.stringify(resultsObj),
          URL: `Formsy/Upsert/Submission/${org}/Insert`,
          Org: org,
          ResponseCode: null,
          ResponseMessage: jsonError.message,
          ExceptionType: `Formsy Clone Error`,
          Application: "React Portal/Formsy",
        };

        writeErrorLog(logData);
        return;
      }

      if (dataJson.SystemResponse?.[0]?.Code === "SUCCESS") {
        toast.update(toastId, {
          render: "Form Cloned",
          type: toast.TYPE.SUCCESS,
          autoClose: 5000,
          isLoading: false,
          closeOnClick: true,
        });

        const trimmedResults = { ...resultsObj };
        delete trimmedResults.FormResults;
        delete trimmedResults.Signatures;
        delete trimmedResults.Comments;

        const logData = {
          Type: `Formsy Clone`,
          Location: logOrg,
          Description: location.pathname,
          Data: JSON.stringify(trimmedResults),
          ObjectReferenceType: "Form",
          ObjectReferenceId: JSON.parse(data).SystemResponse[0].Id,
        };

        writeProcessLog(logData);
        navigate(
          `/${path}/${formid}/${clientid}/${
            JSON.parse(data).SystemResponse[0].Id
          }`,
          { replace: true, state: location.state }
        );
      } else {
        console.log(
          "FormsyCloneError",
          dataJson.SystemResponse[0].Message,
          resultsObj
        );

        const logData = {
          Who: `${safyInfo.user.domainName}|${safyInfo.user.displayName}`,
          FullError: JSON.stringify(dataJson),
          API: "Eureka API",
          APIBody: JSON.stringify(resultsObj),
          URL: `Formsy/Upsert/Submission/${org}/Insert`,
          Org: logOrg,
          ResponseCode: dataJson.SystemResponse[0].Code,
          ResponseMessage: dataJson.SystemResponse[0].Message,
          ExceptionType: `Formsy Clone Error`,
          Application: "React Portal/Formsy",
        };

        writeErrorLog(logData);
      }
    });
  console.groupEnd();
}

export function getFieldLabel(field) {
  return field === undefined
    ? undefined
    : field === null
    ? null
    : field.label || field["@label"];
}

export function getFieldValue(field) {
  return field === undefined
    ? undefined
    : field === null
    ? null
    : field.value || field["@value"];
}

export function getFieldArray(field) {
  const value = field?.value || field?.["@value"] || "[]";
  return JSON.parse(value);
}

export function getFieldOptions(field) {
  const options = !field?.options ? "[]" : field.options.replaceAll("'", '"');
  return JSON.parse(options);
}

export async function cloneWorkerForm(
  data,
  formsyDetails,
  comments,
  signatures,
  location,
  formsyConfig
) {
  console.group("Formsy Clone");
  const safyInfo = JSON.parse(localStorage.getItem("safyInfo")).user;

  const formData = { ...data };
  console.log("Form Data", formData);

  const helperConfig =
    formsyConfig.HelperConfiguration && formsyConfig.HelperConfiguration[0]
      ? JSON.parse(formsyConfig.HelperConfiguration[0])
      : {};
  console.log("Helper Config", helperConfig);

  const excludeCloning = helperConfig.excludeCloning || [];

  for (const fieldName of excludeCloning) {
    const field = formData[fieldName];
    const existingValue = field !== undefined ? field.value : undefined;

    if (existingValue === undefined) {
      continue;
    }

    if (
      existingValue === "[]" ||
      (existingValue.startsWith("[{") && existingValue.endsWith("}]"))
    ) {
      if (
        !formsyConfig.FormConfiguration[0].config[0][fieldName]["@emptyOnClone"]
      ) {
        // eslint-disable-next-line no-useless-escape
        formData[fieldName].value = `[{"_id":"${cryptoRandomString(
          10
        )}","IsEditable":true}]`;
      } else {
        formData[fieldName].value = "[]";
      }
    } else formData[fieldName].value = "";
  }

  // for when you want to exclude specific columns from a "table" field
  // example: excludeCloningTables: [{"tableName": "TableA", "fieldsExcluded": ["FieldA", "FieldB"]}]
  const excludeCloningTables = helperConfig.excludeCloningTables || [];

  console.group("Exclude Cloning");
  excludeCloningTables.forEach((tableInfo) => {
    console.log("Table Info", tableInfo);

    const tableData =
      formData[tableInfo.tableName] !== undefined &&
      formData[tableInfo.tableName].value !== undefined &&
      formData[tableInfo.tableName].value.startsWith("[{") &&
      formData[tableInfo.tableName].value.endsWith("}]")
        ? JSON.parse(formData[tableInfo.tableName].value)
        : [];

    if (tableData !== undefined) {
      console.log("Table Data", tableData);
      tableData.forEach((tableRow) => {
        tableInfo.fieldsExcluded.forEach((fieldName) => {
          tableRow[fieldName] = "";
        });
      });
      console.log("Excluded Table Data", tableData);
      formData[tableInfo.tableName].value = JSON.stringify(tableData);
    }
  });
  console.groupEnd();

  console.log("Pre Clone Data:", formData);

  const resultsObj = convertFormData(
    formData,
    formsyDetails,
    comments,
    signatures
  );
  resultsObj.Comments = "";
  resultsObj.Signatures = "";
  resultsObj.FinalSigned = "0";
  resultsObj.FinalSignedDate = "";
  resultsObj.Active = "1";
  resultsObj.CreatedById = safyInfo.safyInfo.AzureAdId;
  resultsObj.CreatedByName = safyInfo.displayName;
  resultsObj.ModifiedById = safyInfo.safyInfo.AzureAdId;
  resultsObj.ModifiedByName = safyInfo.displayName;

  console.log("Form Clone Object", JSON.stringify(resultsObj));

  var accessToken = await msalInstance.acquireTokenSilent({
    scopes: ["https://eurekaapi.azurewebsites.net/access_as_user"],
  });

  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", `Bearer ${accessToken.accessToken}`);

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: JSON.stringify(resultsObj),
  };
  console.groupEnd();
  return fetch(
    `https://eurekaapi.azurewebsites.net/Formsy/Upsert/Submission/${org}/Insert`,
    requestOptions
  )
    .then((response) => response.json())
    .then((data) => {
      let dataJson;

      try {
        dataJson = JSON.parse(data);
      } catch (jsonError) {
        toast.error("An error has occurred.");

        const fullError = {
          ...JSON.parse(
            JSON.stringify(jsonError, Object.getOwnPropertyNames(jsonError))
          ),
          responseJson: data,
        };
        const logData = {
          Who: `${safyInfo.user.domainName}|${safyInfo.user.displayName}`,
          FullError: JSON.stringify(fullError),
          API: "Eureka API/JS",
          APIBody: JSON.stringify(resultsObj),
          URL: `Formsy/Upsert/Submission/${org}/Insert`,
          Org: org,
          ResponseCode: null,
          ResponseMessage: jsonError.message,
          ExceptionType: `Formsy Clone Error`,
          Application: "React Portal/Formsy",
        };

        writeErrorLog(logData);
        return;
      }

      if (dataJson.SystemResponse?.[0]?.Code === "SUCCESS") {
        const trimmedResults = { ...resultsObj };
        delete trimmedResults.FormResults;
        delete trimmedResults.Signatures;
        delete trimmedResults.Comments;

        const logData = {
          Type: `Formsy Clone`,
          Location: logOrg,
          Description: location.pathname,
          Data: JSON.stringify(trimmedResults),
          ObjectReferenceType: "Form",
          ObjectReferenceId: dataJson.SystemResponse[0].Id,
        };

        writeProcessLog(logData);
        return dataJson.SystemResponse[0].Id;
      } else {
        console.log(
          "FormsyCloneError",
          dataJson.SystemResponse[0].Message,
          resultsObj
        );

        const logData = {
          Who: `${safyInfo.user.domainName}|${safyInfo.user.displayName}`,
          FullError: JSON.stringify(dataJson),
          API: "Eureka API",
          APIBody: JSON.stringify(resultsObj),
          URL: `Formsy/Upsert/Submission/${org}/Insert`,
          Org: logOrg,
          ResponseCode: dataJson.SystemResponse[0].Code,
          ResponseMessage: dataJson.SystemResponse[0].Message,
          ExceptionType: `Formsy Clone Error`,
          Application: "React Portal/Formsy",
        };

        writeErrorLog(logData);
        toast.error("An error has occurred.", {
          autoClose: 5000,
          isLoading: false,
          closeOnClick: true,
        });
      }
    });
}

export async function deleteFormSubmission(
  data,
  formsyDetails,
  comments,
  signatures
) {
  let resultsObj = convertFormData(data, formsyDetails, comments, signatures);
  resultsObj.Comments = "";
  resultsObj.FormResults = "<results></results>";
  resultsObj.FinalSignedDate = "";

  console.log("Deleting Form", resultsObj);

  var accessToken = await msalInstance.acquireTokenSilent({
    scopes: ["https://eurekaapi.azurewebsites.net/access_as_user"],
  });

  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", `Bearer ${accessToken.accessToken}`);

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: JSON.stringify(resultsObj),
  };

  fetch(
    `https://eurekaapi.azurewebsites.net/Formsy/Upsert/Submission/${org}/delete`,
    requestOptions
  )
    .then((response) => response.json())
    .then((data) => {
      if (
        JSON.parse(data).SystemResponse[0].Message ===
        "Form Results Successfully Deactivated"
      ) {
        toast.success("Form Deleted");
      } else {
        toast.error("Error in deleting form");
      }
    });
}

export async function reactivateFormSubmission(
  data,
  formsyDetails,
  comments,
  signatures
) {
  let resultsObj = convertFormData(data, formsyDetails, comments, signatures);
  resultsObj.Comments = "";
  resultsObj.FormResults = "<results></results>";
  resultsObj.FinalSignedDate = "";

  console.log("Deleting Form", resultsObj);

  var accessToken = await msalInstance.acquireTokenSilent({
    scopes: ["https://eurekaapi.azurewebsites.net/access_as_user"],
  });

  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", `Bearer ${accessToken.accessToken}`);

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: JSON.stringify(resultsObj),
  };

  fetch(
    `https://eurekaapi.azurewebsites.net/Formsy/Upsert/Submission/${org}/reactivate`,
    requestOptions
  )
    .then((response) => response.json())
    .then((data) => {
      if (
        JSON.parse(data).SystemResponse[0].Message ===
        "Form Results Successfully Reactivated"
      ) {
        toast.success("Form Reactivated");
      } else {
        toast.error("Error in deleting form");
      }
    });
}

export function saveSignature(signatureData, formsyConfig, formsyDetails) {
  const returnObj = { FormsyDetails: { ...formsyDetails } };
  console.log("Signature Data:", signatureData);
  let sigArray = [];

  if (Array.isArray(signatureData)) {
    sigArray = signatureData;
  } else {
    sigArray.push(signatureData);
  }

  returnObj.Signatures = sigArray;

  if (returnObj.FormsyDetails.FinalSigned === "1") {
    return returnObj;
  }

  if (checkFinalSigned(sigArray, formsyConfig)) {
    console.log("Final Signed");
    returnObj.FormsyDetails.FinalSigned = "1";

    if (
      formsyDetails.FinalSignedDate === "" ||
      formsyDetails.FinalSignedDate === "1900-01-01T00:00:00"
    ) {
      returnObj.FormsyDetails.FinalSignedDate = new Date();
    }
  }

  return returnObj;
}

function checkFinalSigned(sigArray, formsyConfig) {
  const requiredSignatureTypes = JSON.parse(
    formsyConfig.HelperConfiguration[0]
  ).finalSignType.split(",");

  const capturedSignatureTypes = sigArray.map((sig) => sig.signatureType);
  console.log("requiredSignatureTypes: ", requiredSignatureTypes);
  console.log("capturedSignatureTypes: ", capturedSignatureTypes);

  const missingSigTypes = requiredSignatureTypes.filter(
    (type) => !capturedSignatureTypes.includes(type)
  );

  return missingSigTypes.length === 0;
}

export function validateForm(data, schema) {
  let dataObj = {};

  for (const property in data) {
    if (data[property] && data[property].value)
      dataObj[property] = data[property].value;
  }
  console.log("DataOBJ, ", dataObj, data);
  const options = { abortEarly: false };
  const { error } = Joi.validate(dataObj, schema, options);
  if (!error) return {};

  let validationErrors = {};
  for (let item of error.details)
    validationErrors[item.path[0]] = validationErrors[item.path[0]] ? (
      (validationErrors[item.path[0]] = (
        <>
          {validationErrors[item.path[0]]}
          <br />
          <>{item.message}</>
        </>
      ))
    ) : (
      <>{item.message}</>
    );

  console.log("errors: ", validationErrors);
  return validationErrors;
}

export function validateFormProperty(input, schema) {
  const obj = {
    [input.name]: input.type === "checkbox" ? input.checked : input.value,
  };
  const objSchema = { [input.name]: schema[input.name] };
  const { error } = Joi.validate(obj, objSchema);
  return error ? error.details[0].message : null;
}

export function handleFormChange(input, data, schema, errors) {
  const errs = { ...errors };
  const errorMessage = validateFormProperty(input, schema);

  if (errorMessage) {
    errs[input.name] = errorMessage;
  } else {
    delete errs[input.name];
  }

  const value =
    input.type === "checkbox" ? input.checked.toString() : input.value;
  const formData = { ...data };

  if (formData[input.name]) {
    formData[input.name].value = value;
  } else {
    formData[input.name] = {
      type: input.type,
      value: value,
    };
  }

  const returnObj = { Data: formData, Errors: errs };
  return returnObj;
}

export function compareForms(field, data, allFormSubmissions, formsyDetails) {
  if (data.SelectedProgram?.value && formsyDetails.SubmissionId !== "") {
    const latestSubmission = allFormSubmissions
      .filter((submission) => {
        const submissionCreatedOn = moment(submission.CreatedOn).startOf("day");
        const formsyCreatedOn = moment(formsyDetails.CreatedOn).startOf("day");

        return (
          submission.FinalSigned === "1" &&
          `{${submission.ClientProgramId}}` === data.SelectedProgram.value &&
          submissionCreatedOn.isSameOrBefore(formsyCreatedOn) &&
          submission.SubmissionId !== formsyDetails.SubmissionId
        );
      })
      .sort((a, b) => {
        const aDate = new Date(a.CreatedOn);
        const bDate = new Date(b.CreatedOn);

        if (aDate > bDate) return -1;
        if (aDate < bDate) return 1;
        return 0;
      })[0];

    console.log("LatestSubmission", latestSubmission);

    if (
      latestSubmission &&
      data[field] &&
      latestSubmission.FormResults.results[field]
    )
      return (
        data[field].value === latestSubmission.FormResults.results[field].value
      );
    else return false;
  }
}

export async function getFormsySubmissionsForClient(formid, clientid) {
  const response = await getFormsySubmissionsByIds(formid, clientid);

  if (!response) {
    return [];
  }

  const result = JSON.parse(response);

  if (
    !result ||
    !result.FormSubmissions ||
    !result.FormSubmissions.Submission
  ) {
    return [];
  }

  return result.FormSubmissions.Submission;
}

export async function getFormsySubmissionsByFormId(formid, clientid) {
  const response = await getFormsySubmissionsByFormIdForClient(
    formid,
    clientid
  );

  if (!response) {
    return [];
  }

  const result = JSON.parse(response);

  if (
    !result ||
    !result.FormSubmissions ||
    !result.FormSubmissions.Submission
  ) {
    return [];
  }

  return result.FormSubmissions.Submission;
}

export const handleFieldTableChange = (data, e, index, fieldName) => {
  const input = e.currentTarget;

  const value =
    input.type === "checkbox" ? input.checked.toString() : input.value;

  const fieldValue = JSON.parse(data[fieldName].value);
  fieldValue[index][input.name] = value;

  if (!fieldValue[index]._id) {
    fieldValue[index]._id = cryptoRandomString(10);
  }

  return JSON.stringify(fieldValue);
};

export const handleValidatedFieldTableChange = (
  data,
  e,
  index,
  fieldName,
  schema
) => {
  const input = e.currentTarget;
  const value =
    input.type === "checkbox" ? input.checked.toString() : input.value;

  const fieldValue = JSON.parse(data[fieldName].value);
  fieldValue[index][input.name] = value;

  if (!fieldValue[index]._id) {
    fieldValue[index]._id = cryptoRandomString(10);
  }

  const { error } = Joi.validate(
    { [fieldName]: fieldValue },
    { [fieldName]: schema[fieldName] },
    { abortEarly: false }
  );
  const errorMessage = error
    ? error.details.filter(
        (item) => item.path[1] === index && item.path[2] === input.name
      )[0]?.message
    : null;

  if (errorMessage) {
    fieldValue[index].Errors
      ? (fieldValue[index].Errors[input.name] = errorMessage)
      : (fieldValue[index].Errors = { [input.name]: errorMessage });
  } else {
    delete fieldValue[index].Errors?.[input.name];
  }

  return JSON.stringify(fieldValue);
};

export const handleAddFieldTableRow = (
  data,
  fieldName,
  newRow = {},
  unshift = false
) => {
  let fieldValue;

  if (data[fieldName]?.value) fieldValue = JSON.parse(data[fieldName].value);
  else fieldValue = [];

  if (unshift) {
    fieldValue.unshift({ ...newRow, _id: cryptoRandomString(10) });
  } else {
    fieldValue.push({ ...newRow, _id: cryptoRandomString(10) });
  }

  return JSON.stringify(fieldValue);
};

export const handleEditFieldTableRow = (data, index, fieldName) => {
  const fieldValue = JSON.parse(data[fieldName].value);
  fieldValue[index].IsEditable = true;

  if (!fieldValue[index]._id) {
    fieldValue[index]._id = cryptoRandomString(10);
  }

  return JSON.stringify(fieldValue);
};

export const handleSaveFieldTableRow = (data, index, fieldName) => {
  const fieldValue = JSON.parse(data[fieldName].value);
  fieldValue[index].IsEditable = false;

  if (!fieldValue[index]._id) {
    fieldValue[index]._id = cryptoRandomString(10);
  }

  return JSON.stringify(fieldValue);
};

export const handleDeleteFieldTableRow = (data, index, fieldName) => {
  const fieldValue = JSON.parse(data[fieldName].value);
  fieldValue.splice(index, 1);

  return JSON.stringify(fieldValue);
};

export function sendShareEmail(
  recipientList,
  shareComments,
  pathname,
  formData,
  formsyDetails,
  formComments,
  formSignatures,
  formDescription
) {
  const safyInfo = JSON.parse(localStorage.getItem("safyInfo"));

  const shareUrl = `${window.location.origin}/share${pathname}`;

  let body = `<p>${safyInfo.user.displayName} has shared a form. Click the link below to view it. Reply to this email to discuss it with ${safyInfo.user.displayName}.</p><p>${shareUrl}</p>`;
  if (shareComments !== "")
    body = `<p>${safyInfo.user.displayName} has shared a form with comments. Click the link below to view it. Reply to this email to discuss it with ${safyInfo.user.displayName}.</p><p>Comments:</p>${shareComments}<p>${shareUrl}</p>`;

  const toastId = toast.loading("Sending email...");

  sendEmail(
    recipientList,
    safyInfo.user.email,
    `${formDescription}: ${shareComments.slice(0, 500)}`,
    body
  )
    .then(() =>
      toast.update(toastId, {
        render: "Email sent successfully",
        type: "success",
        autoClose: 5000,
        isLoading: false,
        closeOnClick: true,
      })
    )
    .catch((error) =>
      toast.update(toastId, {
        render: `An error has occurred: ${
          JSON.parse(error).SystemResponse[0].Message
        }`,
        type: "error",
        autoClose: 5000,
        isLoading: false,
        closeOnClick: true,
      })
    );

  const splitPath = pathname.split("/");

  const logData = {
    Type: `Formsy Share`,
    Location:
      process.env.REACT_APP_ENVIRONMENT === "Production"
        ? "ReactLive"
        : "ReactDev",
    Description: pathname,
    Data: JSON.stringify(
      convertFormData(formData, formsyDetails, formComments, formSignatures)
    ),
    ObjectReferenceType: "Form",
    ObjectReferenceId: splitPath[4] || splitPath[3],
    SharedBy: safyInfo.user.email,
    SharedTo: JSON.stringify(recipientList),
  };

  writeShareLog(logData);
}

export function handleCopyUrl(pathname) {
  return new Promise((resolve, reject) => {
    const shareUrl = `${window.location.origin}/share${pathname}`;

    navigator.clipboard
      .writeText(`${shareUrl}`)
      .then(() => {
        resolve();
      })
      .catch(() => {
        reject();
      });
  });
}
